export default __webpack_public_path__ + "static/media/import-upload.78c7ec44.png";